// src/context/NavigationContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Create the context
const NavigationContext = createContext();

// Provider component
export const NavigationProvider = ({ children }) => {
  const location = useLocation();
  const [inChatInterface, setInChatInterface] = useState(false);
  const [mobileBannerComponent, setMobileBannerComponent] = useState('default');

  // Update state when the path changes
  useEffect(() => {
    // Check if we're in the chat interface - either at /chat explicitly
    // or on homepage but with an active chat (which renders ChatWindow)
    const isChatPath = location.pathname === '/chat';

    // Check if we have an active chat session from sessionStorage
    const hasActiveChat = sessionStorage.getItem('chatState') !== null;

    // We're in chat interface if either we're on chat path explicitly
    // or on homepage with an active chat
    // OR if we have any mobile banner showing (to hide the floating hamburger)
    const shouldHideFloatingHamburger =
      isChatPath ||
      (location.pathname === '/' && hasActiveChat) ||
      mobileBannerComponent !== 'none'; // Hide floating hamburger when any banner is shown

    setInChatInterface(shouldHideFloatingHamburger);
  }, [location.pathname, mobileBannerComponent]);

  // Reset banner to default on route change (unless manually set)
  useEffect(() => {
    // Don't reset if it was manually set (will be handled by cleanup in useMobileBanner hook)
    return () => {
      // Cleanup happens in individual page hooks
    };
  }, [location.pathname]);

  return (
    <NavigationContext.Provider value={{
      inChatInterface,
      setInChatInterface,
      mobileBannerComponent,
      setMobileBannerComponent
    }}>
      {children}
    </NavigationContext.Provider>
  );
};

// Custom hook for using the context
export const useNavigation = () => useContext(NavigationContext);